import { render } from "./RemoveMemberConfirmationModal.vue?vue&type=template&id=7dcd2ea2&scoped=true"
import script from "./RemoveMemberConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RemoveMemberConfirmationModal.vue?vue&type=script&lang=js"

import "./RemoveMemberConfirmationModal.vue?vue&type=style&index=0&id=7dcd2ea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcd2ea2"]])

export default __exports__